<template>
  <div>
    <v-dialog v-model="assetCategoryFormVueDialog" persistent max-width="450">
      <v-card>
        <v-card-title class="info darken-2 white--text justify-between"
          >{{
            isCreate
              ? text.isCreate + text.title
              : isUpdate
              ? text.isUpdate + text.title
              : "-"
          }}<v-btn
            color="white"
            icon
            @click="assetCategoryFormVueDialog = false"
            ><v-icon>mdi-close</v-icon></v-btn
          ></v-card-title
        >
        <v-card-text class="py-5">
          <!-- Content Space -->
          <v-form ref="formCategory">
            <label>{{ $t('asset.category_name') }}</label>
            <v-text-field
              :label="$t('asset.category_name')"
              v-model="form.name"
              solo
              :rules="[(v) => !!v || $t('validate.please_input_category_name')]"
              background-color="grey lighten-4"
              flat
            ></v-text-field>
            <label>{{ $t('asset.category_name') }}</label>
            <v-text-field
              :label="$t('asset.category_name_en')"
              v-model="form.name_en"
              solo
              :rules="[(v) => !!v || $t('validate.please_input_category_name')]"
              background-color="grey lighten-4"
              flat
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="onCancel">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn
            color="success"
            elevation="0"
            @click="onSave"
            :disabled="isDisable || isLoading"
            :loading="isLoading"
          >
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "AssetCategoryFormVue",
  computed: {
    assetCategoryFormVueDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    value(data) {
      if (data) {
        this.initData();
      }
    },
  },
  created() {
    this.text = {
      title: this.$t('asset.asset_category'),
      isCreate: this.$t('action_type.create'),
      isUpdate: this.$t('action_type.edit'),
    };
  },
  data() {
    return {
      form: {
        name: "",
        name_en: "",
      },
      text: {},
      isLoading: false,
    };
  },
  props: {
    value: Boolean,
    object: Object,
    isDisable: Boolean,
    isUpdate: Boolean,
    isCreate: Boolean,
  },
  methods: {
    async initData() {
      try {
        const params = {};
        if (this.object) {
          this.form = {
            ...this.object,
          };
        }
        this.$emit("onInit");
      } catch (e) {
        console.log(e);
      }
    },
    async saveData() {
      try {
        const params = this.form;
        if (this.isCreate) {
          const response = await this.$store.dispatch(
            "assetCategory/createAssetCategory",
            { ...params, projectId: this.$route.params.projectId }
          );
          return response;
        } else {
          const response = await this.$store.dispatch(
            "assetCategory/updateAssetCategory",
            params
          );
          return response;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async onSave() {
      try {
        this.isLoading = true;
        if (this.$refs.formCategory.validate()) {
          const response = await this.saveData();
          this.assetCategoryFormVueDialog = false;
          this.$emit("onSave", response);
        }
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    onCancel() {
      try {
        this.assetCategoryFormVueDialog = false;
        this.$emit("onCancel", this.form);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
